// extracted by mini-css-extract-plugin
export var container = "_3x-0";
export var disabled = "_3x-4";
export var fullWidth = "_3x-3";
export var lined = "_3x-1";
export var selected = "_3x-5";
export var tab = "_3x-2";